module.exports = __webpack_public_path__ + "img/makeup.c3483c23.png";